/**
 * 所有的响应错误状态码
 */
export default {
  // 用户密码输入错误
  PWD_ERROR: 2021,
  // 开启了谷歌验证码
  OPENED_GOOGLE_CODE: "1904",
  // 谷歌验证码输入错误
  GOOGLE_CODE_ERROR: "1902",
  // 登录地点状况存在异常
  NEED_SECOND_CODE: 40018,
  // 二次验证码输入错误
  SECOND_CODE_ERROR: 20007,
};
